import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import 'react-accessible-accordion/dist/fancy-example.css';
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
//import Util from "../../../Common/util";
import { MDBDataTable } from "mdbreact";
import API from "../../../Common/api";
import _ from "lodash";
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import Alert from "reactstrap/lib/Alert";
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';


var url = window.location.hostname;
var port = window.location.port;
var selectedsubgroup_arr = [];

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.getCookie = this.getCookie.bind(this);
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.getSubGroupId = this.getSubGroupId.bind(this);
    this.onHandover = this.onHandover.bind(this);

    this.state = {
      subGroupIdList: [],
      orderdata: [],
      groupList: [],
      group_id: "",
      location: [],
      modal: false,
      selectedGroup: "",
      selectedSubGroup: "",
      modal1: false,
      modal2: false,
      confirm_modal: false,
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
      isChecked: false,
      success_message: ""
    };
  }


  checkedSingle(index, ischecked, orderid) {

    var arr = [];
    this.setState({
      loading_overlay: true
    })
    let newData = this.state.subGroupIdList;

    if (newData[index].isChecked === false) {
      newData[index].isChecked = true;
      selectedsubgroup_arr.push(orderid);


    } else if (newData[index].isChecked === true) {
      newData[index].isChecked = false;
      var i = selectedsubgroup_arr.indexOf(orderid);
      // console.log(i);
      selectedsubgroup_arr.splice(i, 1);
      // unassignsubgroup_arr.push(orderid);
    }
    this.setState({
      tableRowsMap: this.assembleDispatchData(newData),
      subGroupIdList: newData
    });
    console.log("selectedsubgroup_arr", selectedsubgroup_arr);

  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: Location,

      },
      () => {

      }
    );
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  getSubGroupId() {

    const payload = {
        screen_type: "dispatch_confirm",
        group_id: this.state.selectedGroup,
    };
    addAnalytics('Manual Handover', 'Manual Handover Search Filter', payload);

    API.post('/product/product_master/v1/subgrouplist/', { param: payload })


      .then((response) => response.data)

      .then((data) => {

        var arr = data.data;
        let UnAssignData = arr.map((item) => ({
          ...item,
          isChecked: false,
        }));
        this.setState({ tableRowsMap: this.assembleDispatchData(UnAssignData) })

        this.setState({ subGroupIdList: UnAssignData });
      })

      .then(async () => {

      });
    this.setState({
      modal1: true,

    });
  }
  onHandover() {
    // alert(groupId);

      const payload = {
        "group_id": this.state.selectedGroup,
        "sub_group_ids": selectedsubgroup_arr,
      };

      addAnalytics('Manual Handover', 'Manual Handover', payload);

      API.post('/product/product_master/v1/subgrouplist/', { param: payload })
      .then((response) => response.data)

      .then((data) => {
        this.setState({
          success_message: data.message
        });
      })

      .then(async () => {

      });
    this.setState({
      modal1: false,
      modal2: false,
      confirm_modal: true,

    });
  }

  onGroupChange = (e) => {
    this.setState({
      selectedGroup: e.target.value,
    });
  };

  closeModal = () => {
    this.setState({
      modal1: false,
      modal2: false,
    });
  };
  toggleConfirm = () => {
    this.setState({
      // modal1:false,
      modal2: true,
    });
  };
  successToggle = () => {
    this.setState({
      // modal1:false,
      confirm_modal: false,
    });
  };

  checkAll() {
    if (this.state.isChecked === false) {
      selectedsubgroup_arr.splice(0);
      this.setState({
        isChecked: true,

      });

      let newData = this.state.subGroupIdList.map((item) => ({
        ...item,
        isChecked: true,
      }));
      this.state.subGroupIdList.map((item) => (
        selectedsubgroup_arr.push(item.id)
      ));
      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        subGroupIdList: newData,

      });

    } else if (this.state.isChecked === true) {
      selectedsubgroup_arr.splice(0);
      this.setState({
        isChecked: false,

      });

      let newData = this.state.subGroupIdList.map((item) => ({
        ...item,
        isChecked: false,
      }));

      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        subGroupIdList: newData,

      });
    }
  }
  assembleDispatchData = (dispatchData) => {
    let DispatchData = dispatchData.map((post, index) => {

      return {

        action: <input type="checkbox" value={post.isChecked} checked={post.isChecked} onChange={() => this.checkedSingle(index, post.isChecked, post.id)} />,

        subgroup_id: <span> {post.id}</span>,
        subgroup_name: post.name,

      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { modal, modal1, modal2, confirm_modal, success_message } = this.state;
    // const { SuccessConfirmmodal, Failedmodal } = this.state;

    const dispatchData = {
      columns: [

        {
          label: <input type='checkbox' checked={this.state.isChecked} onChange={() => this.checkAll()} />,

          field: "action",
          width: 35,
        },

        {
          label: "Subgroup Id",

          field: "subgroup_id",
          width: 100,
        },

      ],

      rows: this.state.tableRowsMap,
    };

    return (
      <Col xl={12}>

        {this.state.loading_overlay && (
          <LoadingOverlay active={true} spinner text="wertyui" />
        )}
        <Card>
          <CardBody style={{ paddingTop: 10, height: 60, paddingBottom: 0 }}>


            <form className="form form--inline" onSubmit={handleSubmit}>

              <div
                className="form__form-group col-xl-3"
                style={{ marginBottom: "0px" }}
              >
                <input type="text" style={{ height: 38 }} className="form-control" placeholder="Enter Group Id" onChange={this.onGroupChange} />

              </div>

              <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={() => this.getSubGroupId()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Search
                  </Button>
                </ButtonToolbar>
              </div>

            </form>
          </CardBody>
        </Card>

        <Modal
          isOpen={modal1}
          backdrop="static"
          toggle={this.toggle1}
          style={{ maxWidth: 600, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              SubGroup List
            </h4>
          </div>
          <div className="modal__body modal_table" style={{ marginTop: 10, padding: 10 }}>
            <MDBDataTable
              scrollX
              scrollY
              maxHeight="350px"
              displayEntries={false}
              sortable={false}
              paging={false}
              searching={false}
              striped
              bordered
              data={dispatchData}
            />

            <div style={{ width: "100%", float: "left", marginTop: 20 }}>
              <ButtonToolbar className="modal__footer">
                <button
                  className="modal_cancel"
                  onClick={this.closeModal}
                >
                  Cancel
                </button>

                <Button
                  style={{
                    backgroundColor: "#24d6a3",
                    color: "#fff",
                    marginLeft: 12,
                  }}
                  className="modal_ok"
                  disabled={this.state.disable_submit_button}
                  onClick={this.toggleConfirm}
                >
                  {this.state.ShowConfirmLoader && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  HandOver
                </Button>
              </ButtonToolbar>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={modal2}
          backdrop="static"
          toggle={this.toggle1}
        // style={{ maxWidth: 600, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Please Confirm
            </h4>

          </div>
          <div >
            <p style={{ padding: "30px 50px 20px 50px", fontSize: "16px" }} >Are you sure to move the Sub Groups in Handover Complete status. This action can not be reversed</p>
          </div>

          <div style={{ width: "100%", float: "left", marginTop: 20 }}>
            <ButtonToolbar className="modal__footer">
              <button
                className="modal_cancel"
                onClick={this.closeModal}
              >
                Cancel
              </button>

              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.onHandover}
              >
                {/* {this.state.ShowConfirmLoader && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )} */}
                Confirm
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>
        <Modal
          isOpen={confirm_modal}
          backdrop="static"

        >
          <div
            className="modal__body"
            style={{ paddingTop: 40, paddingBottom: 10 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6", paddingBottom: 10 }}
            />
            <h4>{success_message} </h4>
          </div>
          <div >
          </div>

          <div style={{ width: "100%", float: "left", marginTop: 20 }}>
            <ButtonToolbar className="modal__footer">
              <Button
                style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                className="modal_ok"
                onClick={this.successToggle}
              >
                Ok
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>
      </Col>
    )
  }
}


export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
